import React, { useEffect, useState } from "react";

import { getCapitulos } from "../../services/firebase/firestore";

import AdminCapituloForm from "./AdminCapituloForm";


const AdminCapitulos = () => {

    const [capitulos, setCapitulos] = useState([]);

    const [capituloEditando, setCapituloEditando] = useState(null);
    const [creandoCapitulo, setCreandoCapitulo] = useState(false);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [mensaje, setMensaje] = useState("");


    useEffect(() => {

        getCapitulos()
            .then(response => {

                const capitulosOrdenados = [...response].sort((a, b) =>
                    (a.capitulo || "").localeCompare(
                        b.capitulo || "",
                        undefined,
                        { numeric: true }
                    )
                );

                setCapitulos(capitulosOrdenados);

            })
            .catch(error => {

                console.error(error);
                setError("No se pudieron cargar los capítulos.");

            })
            .finally(() => {

                setLoading(false);

            });

    }, []);


    const ordenarCapitulos = (items) => {

        return [...items].sort((a, b) =>
            (a.capitulo || "").localeCompare(
                b.capitulo || "",
                undefined,
                { numeric: true }
            )
        );

    };


    const handleAgregar = () => {

        setMensaje("");
        setCapituloEditando(null);
        setCreandoCapitulo(true);

    };


    const handleEditar = (capitulo) => {

        setMensaje("");
        setCreandoCapitulo(false);
        setCapituloEditando(capitulo);

    };


    const handleClose = () => {

        setCreandoCapitulo(false);
        setCapituloEditando(null);

    };


    const handleSaved = (capituloActualizado) => {

        setCapitulos(prev => {

            const existe = prev.some(
                capitulo => capitulo.id === capituloActualizado.id
            );

            const nuevosCapitulos = existe
                ? prev.map(capitulo =>
                    capitulo.id === capituloActualizado.id
                        ? capituloActualizado
                        : capitulo
                )
                : [...prev, capituloActualizado];

            return ordenarCapitulos(nuevosCapitulos);

        });


        if (creandoCapitulo) {

            setCreandoCapitulo(false);
            setCapituloEditando(null);

            setMensaje(
                "Capítulo creado correctamente."
            );

        } else {

            setCapituloEditando(capituloActualizado);

        }

    };


    const handleDeleted = (capituloId) => {

        setCapitulos(prev =>
            prev.filter(
                capitulo => capitulo.id !== capituloId
            )
        );

        setCapituloEditando(null);
        setCreandoCapitulo(false);

        setMensaje(
            "Capítulo eliminado correctamente."
        );

    };


    if (loading) {

        return (
            <p>
                Cargando capítulos...
            </p>
        );

    }


    if (error) {

        return (
            <p className="admin-error">
                {error}
            </p>
        );

    }


    if (creandoCapitulo) {

        return (
            <AdminCapituloForm
                onClose={handleClose}
                onSaved={handleSaved}
                onDeleted={handleDeleted}
            />
        );

    }


    if (capituloEditando) {

        return (
            <AdminCapituloForm
                capitulo={capituloEditando}
                onClose={handleClose}
                onSaved={handleSaved}
                onDeleted={handleDeleted}
            />
        );

    }


    return (
        <div className="admin-capitulos">

            <div className="admin-section-title">

                <h2>
                    Capítulos
                </h2>

                <div className="admin-section-actions">

                    <span>
                        {capitulos.length} capítulos
                    </span>

                    <button
                        type="button"
                        onClick={handleAgregar}
                    >
                        + Agregar capítulo
                    </button>

                </div>

            </div>


            {mensaje &&
                <p className="admin-success">
                    {mensaje}
                </p>
            }


            <div className="admin-obras-list">

                {capitulos.map(capitulo => (

    <div
        className="admin-obra-row"
        key={capitulo.id}
    >

        <div
            className="admin-obra-img"
            style={{
                backgroundImage:
                    `url('/img/pyro/${capitulo.img}')`
            }}
        ></div>


        <div className="admin-obra-info">

            <strong>
                {capitulo.capitulo || capitulo.id}
            </strong>

            <span>
                {capitulo.titulo || "Sin título"}
            </span>

        </div>


        <div className="admin-obra-status">

            {capitulo.link &&
                <a
                    href={capitulo.link}
                    target="_blank"
                    rel="noreferrer"
                    className="admin-link"
                >
                    Ver link
                </a>
            }

        </div>


        <button
            type="button"
            onClick={() =>
                handleEditar(capitulo)
            }
        >
            Editar
        </button>

    </div>

))}

            </div>

        </div>
    );

};


export default AdminCapitulos;